export default "__VITE_ASSET__DwYkER9g__"